import { configureStore } from '@reduxjs/toolkit';
import userDatasReducer from "./features/userDatasSlice";
import standardsReducer from './features/standardsSlice';
import bellNotificationsReducer from './features/bellNotificationsSlice';
import notificationsReducer from './features/notificationsSlice';
import unreadDeviceStatusReducer from './features/unreadDeviceStatusSlice';
import notificationStatusReducer from './features/notificationStatusSlice';
import thresholdLinesReducer from './features/thresholdLinesSlice';
import devicesReducer from './features/devicesSlice';

const store = configureStore({
    reducer: {
        userDatas: userDatasReducer,
        standards: standardsReducer,
        bellNotifications: bellNotificationsReducer,
        notifications: notificationsReducer,
        unreadDeviceStatus: unreadDeviceStatusReducer,
        notificationStatus: notificationStatusReducer,
        thresholdLines: thresholdLinesReducer, 
        devices: devicesReducer
    },
});

export default store;
